module.exports = __webpack_public_path__ + "img/lottie-step-2.8d1a3e75.png";